import { shopId } from "../config/const";
import { callFetch, idTokenHeader, tokenHeader } from "./utils";

const EndPoint = {
  GetOrders: (lineId) => `/linewebhook/order/shop/${shopId}/${lineId}`,
  GetOrder: (lineId, orderId) =>
    `/linewebhook/order/shop/${shopId}/${lineId}/${orderId}`,
  SubmitOrder: (lineId) => `/linewebhook/order/shop/${shopId}/${lineId}`,
  SubmitRefund: (lineId) =>
    `/linewebhook/refund/shop/${shopId}/apply/${lineId}`,
  CancelOrder: (lineId, orderId) =>
    `/linewebhook/order/shop/${shopId}/${lineId}/${orderId}/cancel`,
  GetPaymentLink: (lineId, orderId) =>
    `/linewebhook/order/shop/${shopId}/${lineId}/${orderId}/payment-link`,
  GetRewardPoint: (lineId, items) =>
    `/linewebhook/order/shop/${shopId}/${lineId}/reward-point?items=${items}`,
  GetPurchaseNowLink: (lineId, items) =>
    `/linewebhook/order/shop/${shopId}/${lineId}/purchase-now-link?items=${
      items ? `items=${items}` : ""
    }`,
  GetPurchaseLink: (lineId, orderId) =>
    `/linewebhook/order/shop/${shopId}/${lineId}/${orderId}/purchase-link`,
  PingHasEcid: (lineId) => `/api/shop/${shopId}/customer/${lineId}/hasecid`,
};

// Order

export function getOrders(lineId, idToken) {
  const uri = EndPoint.GetOrders(lineId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function submitOrder(lineId, idToken, customerMeta, carts) {
  const uri = EndPoint.SubmitOrder(lineId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ items: carts, meta: customerMeta }),
  };

  return callFetch(uri, settings);
}

export function getPurchaseLink(lineId, idToken, orderId) {
  const uri = EndPoint.GetPurchaseLink(lineId, orderId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getPurchaseNowLink(lineId, idToken, items) {
  const uri = EndPoint.GetPurchaseNowLink(lineId, items);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getPaymentLink(lineId, idToken, orderId) {
  const uri = EndPoint.GetPaymentLink(lineId, orderId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getRewardPoint(lineId, idToken) {
  const uri = EndPoint.GetRewardPoint(lineId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function pingHasEcid(lineId) {
  const uri = EndPoint.PingHasEcid(lineId);
  let settings = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  return callFetch(uri, settings);
}

export function getOrder(lineId, orderId, idToken) {
  const uri = EndPoint.GetOrder(lineId, orderId);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function submitRefund(lineId, orderId, idToken, data) {
  const uri = EndPoint.SubmitRefund(lineId, orderId);
  let formData = new FormData();
  data.files.forEach((file) => {
    formData.append("files", file, file.name);
  });
  formData.append("order_id", orderId);
  formData.append("reason", data.reason);

  let headers = new Headers();
  headers.append("tappie-id-token", idToken.token);

  let settings = {
    method: "POST",
    headers: headers,
    body: formData,
  };

  return callFetch(uri, settings);
}

export function cancelOrder(lineId, orderId, idToken) {
  const uri = EndPoint.CancelOrder(lineId, orderId);
  let settings = {
    method: "POST",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}
